import styled, { css } from 'styled-components';
import Typography from 'ggApp/shared/components/typography';
import {
    LayoutComponent_Grid_Row as Row,
    LayoutComponent_Grid_Col as Col,
} from 'ggApp/modules/layout';

export const StyledRow = styled(Row)`
    ${(props) => props.multipleProducts
        && css`
            border-bottom: 2px solid ${({ theme }) => theme.colors['Level 1']};
        `}
    align-items: normal;
`;

export const ColumnValue = styled.div`
    color: ${({ theme }) => theme.colors.Foreground};
    ${(props) => css(props.theme.typography.Paragraph)};
    > * {
        display: inline;
    }
`;

export const ColumnSubValue = styled(Typography).attrs({
    tag: 'h4',
})`
    color: ${({ theme }) => theme.colors['Level 4']};
    padding-top: ${({ theme }) => theme.spacers.M};
`;

export const ColTitle = styled(Typography).attrs({
    tag: 'p',
})`
    margin-bottom: ${({ theme }) => theme.spacers.M};
    font-weight: bold;
    color: ${({ theme }) => theme.colors.Foreground};
`;

export const StyledRowIn = styled(Row)`
    overflow: hidden;
    height: 100%;

    ${(props) => props.singleProduct
        && css`
            border-bottom: 2px solid ${({ theme }) => theme.colors['Level 1']};
        `}

    > div {
        display: flex;
        position: relative;
        padding: ${({ theme }) => theme.spacers.L};

        &:after {
            position: absolute;
            content: ' ';
            display: block;
            width: 2px;
            top: 50%;
            left: 0;
            height: 500px;
            margin-top: -250px;
            background: ${({ theme }) => theme.colors['Level 1']};
        }

        &:nth-child(2) {
            text-align: center;
            padding-left: 0;
        }

        &:last-child {
            text-align: right;
            padding-top: 15px;
            padding-bottom: 15px;
            padding-left: 0;

            &:after {
                display: none;
            }
        }
    }
`;

export const Remover = styled.div`
    display: inline-block;
    align-self: flex-end;
    width: 25px;
    height: 25px;
    background: #f4f3f3;
    color: #000;
    border-radius: 2px;

    line-height: 21px;
    text-align: center;
    font-size: 22px;
    cursor: pointer;
    transition: all 0.2s ease;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    &:hover {
        background: #f7f5f5;
    }
`;

export const StyledCol = styled(Col)`
    position: relative;
`;
